function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 120.006,
  y: 58.0007,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(90 120.006 58.0007)",
  fill: "#F0F2F5"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 8.00586,
  y: 58.0007,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(90 8.00586 58.0007)",
  fill: "#F0F2F5"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 113.63,
  y: 32.0671,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(64.2857 113.63 32.0671)",
  fill: "#F0F2F5"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 12.7217,
  y: 80.6621,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(64.2857 12.7217 80.6621)",
  fill: "#F0F2F5"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 96.6328,
  y: 11.4675,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(38.5714 96.6328 11.4675)",
  fill: "#F0F2F5"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 72.3818,
  y: 0.282959,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(12.8571 72.3818 0.282959)",
  fill: "#F0F2F5"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 45.6797,
  y: 0.727295,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(-12.8571 45.6797 0.727295)",
  fill: "#F0F2F5"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 21.8145,
  y: 12.7146,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(-38.5714 21.8145 12.7146)",
  fill: "#F0F2F5"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 5.51367,
  y: 33.8689,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(-64.2857 5.51367 33.8689)",
  fill: "#F0F2F5"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 106.423,
  y: 82.4639,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(-64.2857 106.423 82.4639)",
  fill: "#F0F2F5"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M58.4544 40.7723C59.3288 38.4092 62.6712 38.4092 63.5456 40.7723L67.348 51.0483C67.623 51.7913 68.2087 52.377 68.9517 52.652L79.2277 56.4544C81.5908 57.3288 81.5908 60.6712 79.2277 61.5456L68.9517 65.348C68.2087 65.623 67.623 66.2087 67.348 66.9517L63.5456 77.2277C62.6712 79.5908 59.3288 79.5908 58.4544 77.2277L54.652 66.9517C54.377 66.2087 53.7913 65.623 53.0483 65.348L42.7723 61.5456C40.4092 60.6712 40.4092 57.3288 42.7723 56.4544L53.0483 52.652C53.7913 52.377 54.377 51.7913 54.652 51.0483L58.4544 40.7723Z",
  fill: "#F0F2F5"
});

function SvgStarInactiveWithDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 86,
    viewBox: "0 0 120 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarInactiveWithDots);
export default __webpack_public_path__ + "static/media/star-inactive-with-dots.42430d6f.svg";
export { ForwardRef as ReactComponent };